import React from "react";

import { XCircle } from "react-feather";

import "./styles.scss";

export const EmptyMessage = ({ t }) => {
    return (
        <div className="prime-data-table-message">
            <XCircle />
            <p>{t("No records found")}</p>
        </div>
    );
};
